import { colors } from '@constants/colors';
import { isMobileOnly } from 'react-device-detect';

export const useStyles = () => {
  return {
    tag: {
      color: colors.white,
      background: colors.myta,
      fontSize: 8,
      lineHeight: 1,
      borderRadius: '3px',
      padding: isMobileOnly ? '2px' : 0.5,
      height: 'fit-content',
      textTransform: 'uppercase',
    },
  };
};
